import React from "react";

export class CoreReducer {
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(dispatcher: any) {}
  static getInitialState(initialState: Object): any {}
  static reducer(state: any, action: any): any {}
}

type ReducerClassType = typeof CoreReducer;

export function useReducerWrapper<T, R>(classRef: ReducerClassType, initialState: Object = {}): [T, R] {
  const [state, dispatch] = React.useReducer(classRef.reducer, classRef.getInitialState(initialState));

  const dispatcher: any = React.useMemo(() => {
    return new classRef(dispatch);
  }, [classRef]);

  return [state, dispatcher];
}
